"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TextInput_1 = __importDefault(require("components/common/inputs/TextInput"));
var Checkbox_1 = __importDefault(require("components/common/inputs/Checkbox"));
var mobx_react_1 = require("mobx-react");
var EditProductOptionsItem = mobx_react_1.observer(function (_a) {
    var productOptionItem = _a.productOptionItem, optionGroup = _a.optionGroup, otherGroups = _a.otherGroups, onRemoveItem = _a.onRemoveItem, onChange = _a.onChange;
    var productOptionItemValue = productOptionItem.productOptionItemValue;
    var keyTimeoutRef = react_1.useRef(null);
    var keyHandler = function (e) {
        var name = e.currentTarget.name;
        var value = e.currentTarget.value;
        var numberEx = /^[+-]?\d+(\.\d+)?$/;
        if (numberEx.test(value)) {
            value = Math.round(value * 100) / 100;
        }
        clearTimeout(keyTimeoutRef.current);
        keyTimeoutRef.current = setTimeout(function () {
            var _a;
            onChange(__assign(__assign({}, productOptionItemValue), (_a = {}, _a[name] = value, _a)));
        }, 300);
    };
    var changeHandler = function () {
        onChange(__assign(__assign({}, productOptionItemValue), { useOwn: !productOptionItemValue.useOwn }));
    };
    var changeHandler2 = function () {
        onChange(__assign(__assign({}, productOptionItemValue), { featured: !productOptionItemValue.featured }));
    };
    var checkShouldDisable = function () {
        for (var _i = 0, otherGroups_1 = otherGroups; _i < otherGroups_1.length; _i++) {
            var otherGroup = otherGroups_1[_i];
            if (otherGroup.id === optionGroup.id)
                continue;
            for (var _a = 0, _b = otherGroup.productOptionItems; _a < _b.length; _a++) {
                var item = _b[_a];
                if (item.productOptionItemValue.useOwn)
                    return true;
            }
        }
        return false;
    };
    return (react_1.default.createElement("div", { className: 'edit-product-options-item form' },
        react_1.default.createElement("div", { className: 'flex flex-row flex-space-between' },
            react_1.default.createElement("span", { className: 'title' },
                productOptionItem.name,
                ":"),
            react_1.default.createElement(Checkbox_1.default, { disabled: checkShouldDisable(), checked: productOptionItemValue.useOwn, label: 'Has own price / stock?', onChange: changeHandler }),
            react_1.default.createElement(Checkbox_1.default, { checked: productOptionItemValue.featured, label: 'Featured?', onChange: changeHandler2 }),
            react_1.default.createElement("button", { type: 'button', "aria-label": 'Remove Option', className: 'edit-product-options-item__remove flex flex-column flex-center', onClick: function () { return onRemoveItem(productOptionItemValue); }, title: 'Remove' }, "Remove")),
        productOptionItemValue.useOwn &&
            react_1.default.createElement("div", { className: 'edit-product-options-item__value__inputs flex flex-row' },
                react_1.default.createElement(TextInput_1.default, { type: 'number', step: 0.01, min: 0, name: 'price', defaultValue: productOptionItemValue.price, onKeyUp: keyHandler, placeholder: '0.00' }),
                react_1.default.createElement(TextInput_1.default, { type: 'number', step: 0.01, min: 0, max: productOptionItemValue.price, name: 'pricePromo', defaultValue: productOptionItemValue.pricePromo, onKeyUp: keyHandler, placeholder: '0.00' }),
                react_1.default.createElement(TextInput_1.default, { type: 'number', step: 1, min: 1, name: 'stock', defaultValue: productOptionItemValue.stock, onKeyUp: keyHandler, placeholder: '0' }))));
});
exports.default = EditProductOptionsItem;
